import { QueryResources } from 'datx-jsonapi-react';

import { EventHubCounters } from '@/resources/EventHubCounters';

export const queryEventHubCounters = (event_id: Array<string>, hub_id: string): QueryResources<EventHubCounters> => {
  if (event_id.length === 0) return null;
  if (!hub_id) return null;
  return [
    EventHubCounters,
    {
      filter: {
        event_id,
        hub_id,
      },
      params: [
        { key: 'page[number]', value: '1' },
        {
          key: 'page[size]',
          value: '100',
        },
      ],
    },
  ];
};
